import React from "react";
import { Heading } from "../../design/heading";
import EmptyStateView from "../../components/EmptyStateView";
import ErrorView from "../../components/ErrorView";
import LoadingView from "../../components/LoadingView";
import { useMatter } from "../../contexts/MatterContext";
import { useFinancialItem } from "../../contexts/FinancialItemContext";
import { financialItemTypes } from "../../models/FinancialItemType";
import FinancialItemListSection from "./FinancialListSection";
import FinancialStatsSummary from "./FinancialStatsSummary";
import { PropertyDivisionUpsellCard } from "./components/PropertyDivisionUpsellCard";
import { useCreateFinancialItemDialog } from "../../providers/CreateFinancialItemDialogProvider/CreateFinancialItemDialogProvider";
import { Button } from "../../design/button";
import { PlusIcon } from "@heroicons/react/16/solid";
import { Navbar, NavbarItem } from "../../design/navbar";
import AssetListPage from "./AssetListPage";
import DebtListPage from "./DebtListPage";

const AssetAndDebtsPage: React.FC = () => {
  const { openDialog } = useCreateFinancialItemDialog();
  const { currentMatter } = useMatter();
  const { financialItems, loading, error } = useFinancialItem();
  const [state, setState] = React.useState<"assets" | "debts">("assets");

  if (loading.list) {
    return <LoadingView title="Loading Assets & Debts..." />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <div>
      {!currentMatter?.unlockedFeatures?.includes("financial_disclosures") && (
        <PropertyDivisionUpsellCard />
      )}
      {currentMatter?.unlockedFeatures?.includes("financial_disclosures") && (
        <div className="space-y-4">
          <div className="flex items-end justify-between gap-4 mb-6">
            <Heading className="text-2xl font-bold">Assets & Debts</Heading>
          </div>

          <FinancialStatsSummary items={financialItems} />

          <Navbar>
            <NavbarItem
              current={state === "assets"}
              onClick={() => setState("assets")}
            >
              Assets
            </NavbarItem>
            <NavbarItem
              current={state === "debts"}
              onClick={() => setState("debts")}
            >
              Debts
            </NavbarItem>
          </Navbar>

          {state === "assets" && <AssetListPage />}
          {state === "debts" && <DebtListPage />}
        </div>
      )}
    </div>
  );
};

export default AssetAndDebtsPage;
